module.exports = __webpack_public_path__ + "img/F974.7edd6627.jpg";